import React, { Component } from "react";
import tw from "twin.macro";
import styled from "styled-components";

const FormPage = styled.div`
  ${tw`w-full mx-auto px-8`}
  max-width: 1448px;
`;
const FlexCenter = styled.div`
  ${tw`flex flex-1 justify-center items-center pt-3`}
  min-height: auto;
  height: 100%;

  @media screen and (min-height: 1080px) {
    min-height: calc(100vh - 70.84px);
  }
`;
const SecondCol = styled.div`
  @media screen and (min-width: 1561px) {
    margin-left: 8.5vw;
  }
`;

//eslint-disable-next-line react/display-name
const withWrap = (WrappedComponent) => {
  return class extends Component {
    componentDidMount() {
      document.body.classList.add("sessions");
    }

    componentWillUnmount() {
      document.body.classList.remove("sessions");
    }

    render() {
      return (
        <FormPage>
          <FlexCenter>
            <SecondCol>
              <WrappedComponent {...this.props} />
            </SecondCol>
          </FlexCenter>
        </FormPage>
      );
    }
  };
};

export default withWrap;
